export const styles = (theme) => ({
  p: {
    fontFamily: theme.font.paragraph,
    margin: `${theme.spacing.S} auto`,
  },
  iframe: {
    width: '100%',
  },
})
